import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bank"
const BankIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.75 21.75H2.25V20.25H21.75zM6.75 18.75H5.25V11.25H6.75zM12.75 18.75H11.25V11.25H12.75zM18.75 18.75H17.25V11.25H18.75z" />
          <path
            fillRule="evenodd"
            d="M11.503 2.434C11.763 2.246 12.102 2.222 12.381 2.364L12.497 2.433 20.458 8.224C21.118 8.704 20.778 9.75 19.961 9.75H4.04C3.22 9.75 2.88 8.705 3.542 8.224zM6.057 8.25H17.943L12 3.928z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BankIcon
